import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as yup from 'yup';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Locale, UserTypology } from 'helpers/Enums';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';

interface IUserContext {
    isLoading: boolean
    user: User

    saveUser: (user: User) => void
}

export let userSchema = yup.object().shape({
    userId: yup.string(),
    firstName: yup.string().default('').required().label("First name"),
    lastName: yup.string().default('').required().label("Last name"),
    email: yup.string().default('').required().label("Email"),
    isAdmin: yup.boolean().default(false).label("Is Admin"),
    typology: yup.string().default(UserTypology.Customer).label("Typology"),
    language: yup.string().default(Locale.Italian).label("Language")
});

type User = yup.InferType<typeof userSchema>;

export let customerUserContext = React.createContext({} as IUserContext);

let { Provider } = customerUserContext;

let CustomerUserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let { formatMessage } = useIntl();
    let { id } = useParams<{ id: string }>();
    let location = useLocation();
    let history = useHistory();
    let { enqueueSnackbar } = useSnackbar();

    let isNew = location.pathname.includes("/addnew");

    let [isLoading, setLoading] = useState<boolean>(isNew === false);
    let [user, setUser] = useState<User>(userSchema.getDefault());

    useEffect(() => {
        if (isNew === false)
            getUser();

    }, [id, isNew])

    let getUser = async () => {
        try {
            let res = await axios.get('/api/CustomerUser/GetUser', { params: { userId: id } });

            let { item } = res.data;
            setUser({
                ...item,
                adminArea: item.adminArea ?? [],
                groups: item.groups ?? [],
                enabledLocales: item.enabledLocales ?? [],
            });
            setLoading(false);

        } catch (err) { }
        finally {
        }
    }

    let saveUser = async (value: User) => {
        try {
            await axios.post('/api/CustomerUser/SaveUser', value);
            enqueueSnackbar(formatMessage({ id: LocalizationIds.UserSaved }), { variant: "success" });
            history.push(`/customer/users`);

        } catch (err) {
        }
    }

    

    return (
        <Provider
            value={{
                isLoading,
                user,

                saveUser
            }}
        >
            {children}
        </Provider>
    )
}

export default CustomerUserProvider;